import React from "react";

import { useTranslation } from "react-i18next";
import CRUD from "../core/genericCRUD/CRUD";
import { parsedUser } from "../../common/GetCurrentUser";

const ClientTypeComponent = (props: any) => {
  const [t] = useTranslation("global");
  const user = parsedUser();
  return (
    <CRUD
      cssClass="modalRight"
      isModal={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Customer Types") ?? ""}
      getRecordsPath={`customerType/list?OrganizationId=${user.OrganizationId}`}
      addEditRecordPath={`customerType/AddEdit`}
      deleteRecordPath="customerType/Delete"
      fieldsList={[
        {
          name: "name",
          title: t("name"),
        },
      ]}
      filterFields={[
        {
          name: "search",
          htmlType: "text",
          dbType: "string",
          title: t("search") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
        },
      ]}
      fields={[
        {
          name: "id",
          htmlType: "hidden",
          dbType: "string",
        },
        {
          name: "name",
          htmlType: "text",
          dbType: "string",
          title: t("name") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },

        {
          name: "organizationId",
          htmlType: "hidden",
          dbType: "string",
          //title: t("value")??"",
          containerClass: "col-6",
          required: true,
          value: user.OrganizationId,
        },
      ]}
    />
  );
};

export default ClientTypeComponent;
